// extracted by mini-css-extract-plugin
export default {"header":"Header_header__0rCrq","header_link":"Header_header_link__mctmV","header_title":"Header_header_title__psxTR"};